export interface ChatbotMessage {
  date?: string;
  time?: string;
  userId?: string;
  sessionId?: string;
  questionId?: string;
  type?: MessageType;
  // Question
  question?: string;
  text?: string;
  source?: SourceType;
  // Answer
  answer?: string;
  documents?: DocumentSource[];
  answerReactions?: AnswerReaction;
  query?: string;
  result?: any;
  columns?: any;
  // Table rendering support (per-message)
  tableRowData?: any[];
  tableColumnDefs?: any[];
  showTable?: boolean;
  status?: Status; // Added status property
}

export interface Status {
  status_code: number;
  message: string;
  detail: string;
}

export enum AnswerReaction {
  LIKED = 'LIKED',
  DISLIKED = 'DISLIKED'
}

export enum SourceType {
  HSE = 'HSE',
  REX = 'REX'
}

export enum MessageType {
  QUESTION = 'QUESTION',
  ANSWER = 'ANSWER'
}

export interface DocumentSource {
  name: string;
  url: string;
}

export enum language {
  FR = 'fr',
  EN = 'en',
  AR = 'ar',
  ES = 'es',
  NL = 'nl',
  KM = 'km',
  DE = 'de'
}
